import React from "react";
import { DashboardsEmbedWrapper } from "./dashboardEmbed";
import PropTypes from 'prop-types';

function DashboardVisualizationReportPage(props) {
  const dashboardId = props?.match?.params?.dashboardId?.trim();

  return (
    <div className="card">
      <div className="card-header text-light font-weight-bold container-fluid">
        <div className="row">
          <div className="col-12">Dashboard Visualization</div>
        </div>
      </div>
      <div>
        {dashboardId ? (
          <DashboardsEmbedWrapper dashboardId={dashboardId} />
        ) : (
          <div className="alert alert-warning">No dashboard specified</div>
        )}
      </div>
    </div>
  );
}

DashboardVisualizationReportPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

export default DashboardVisualizationReportPage;